import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, OnChanges, OnInit, PLATFORM_ID, Renderer2, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-json-ld',
  templateUrl: './json-ld.component.html',
  styleUrls: ['./json-ld.component.scss']
})
export class JsonLdComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('jsonLdDiv', { static: true }) jsonLdElement: any;
  @Input() jsonLd: any
  constructor(
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: any,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (isPlatformBrowser(this.platformId) && this.jsonLd) {
      const script = this.renderer.createElement('script')
      script.setAttribute('type', 'application/json')
      script.text = JSON.stringify(this.jsonLd)
      this.renderer.appendChild(this.jsonLdElement.nativeElement, script)
    }
  }

  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId) && this.jsonLd) {
      const script = this.renderer.createElement('script')
      script.setAttribute('type', 'application/json')
      script.text = this.jsonLd
      this.renderer.appendChild(this.jsonLdElement.nativeElement, script)
    }
  }
}
